import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ArrowDownIcon from '../../../../assets/icons/arrowDown.svg';
import ImpactDescriptionWrapper from '../ImpactDescriptionWrapper';
import styles from './SpliceDescription.css';
const ARROW_DOWN_ICON_WIDTH = 18;
const ARROW_DOWN_ICON_HEIGHT = 18;
const SpliceDescription = () => (_jsxs(ImpactDescriptionWrapper, { children: [_jsx(ArrowDownIcon, { width: ARROW_DOWN_ICON_WIDTH, height: ARROW_DOWN_ICON_HEIGHT, className: styles.icon, "data-testid": "arrow-icon" }, void 0), "splice variants"] }, void 0));
export default SpliceDescription;
